const content = {
  app: {
    skipLink: 'Перейти к содержимому',
  },
  header: {
    discussTask: 'Обсудить задачу',
    viewProjects: 'Смотреть проекты',
    closeMenu: 'Закрыть меню',
    openMenu: 'Открыть меню',
    mainNavigation: 'Основная навигация',
    mobileNavigation: 'Мобильная навигация',
    brandHomeLabel: (name) => `${name} — на главную`,
  },
  home: {
    metaTitle: 'Разработка и сопровождение информационных систем',
    metaDescription:
      'Проектируем, разрабатываем и сопровождаем информационные системы для бизнеса и государственных заказчиков. ООО «Преобразование», Санкт-Петербург.',
    heroEyebrow: 'ИТ-компания · Санкт-Петербург',
    heroTitle: ['Преобразуем ', 'идеи', ' в ', 'решения'],
    placeholderStatTitle: 'Значение-заглушка, заменить реальными данными',
    servicesTitle: 'Направления работы',
    servicesDescription: 'Основные направления деятельности, закреплённые в ОКВЭД.',
    hideServices: 'Скрыть дополнительные направления',
    showServices: (count) => `Показать еще ${count} направлений`,
    processTitle: 'Как проходит работа',
    processDescription:
      'Это общий флоу: этапы подбираем и при необходимости меняем под конкретный продукт. Результаты и сроки фиксируем в договоре.',
    process: [
      {
        title: 'Обследование',
        text: 'Разбираемся в задаче, фиксируем требования и критерии приёмки.',
      },
      {
        title: 'Архитектура',
        text: 'Собираем техническое решение и прототип до первой строки кода.',
      },
      {
        title: 'Разработка',
        text: 'Работаем этапами и показываем результат каждые две недели.',
      },
      {
        title: 'Эксплуатация',
        text: 'Передаём документацию, обучаем пользователей и сопровождаем систему.',
      },
    ],
    productsTitle: 'Собственные продукты',
    productsDescription: 'То, что мы делаем сами: от идеи и архитектуры до поддержки пользователей.',
    tenderTitle: 'Работаем с государственными и корпоративными закупками',
    tenderDescription:
      'Готовим документы под требования закупочной комиссии и отвечаем на запросы коммерческих предложений.',
    tenderPoints: [
      'Полный комплект учредительных документов и карточка предприятия',
      'Подтверждение опыта по исполненным контрактам',
      'Готовность к обеспечению исполнения контракта',
    ],
    requisitesTitle: 'Реквизиты',
    companyNameLabel: 'Наименование',
    innLabel: 'ИНН',
    kppLabel: 'КПП',
    ogrnLabel: 'ОГРН',
    okvedLabel: 'ОКВЭД',
    tenderNote:
      'Юридический адрес и банковские реквизиты - в карточке предприятия. Пришлём по запросу вместе с остальными документами.',
  },
  projects: {
    metaTitle: 'Проекты',
    metaDescription:
      'Собственные продукты ООО «Преобразование» и проекты, выполненные для заказчиков.',
    eyebrow: 'Проекты',
    title: 'Что мы сделали',
    lead:
      'Собственные продукты, которые мы развиваем сами, и работы для заказчиков. По проектам, которых нет в списке, расскажем на встрече.',
    ownProductsCount: (count) => `Собственных продуктов: ${count}`,
    location: 'Санкт-Петербург',
  },
  notFound: {
    metaTitle: 'Страница не найдена',
    metaDescription: 'Запрошенная страница не существует или была перемещена.',
    title: 'Страница не найдена',
    description:
      'Возможно, адрес изменился или в ссылке опечатка. Начните с главной — там есть всё основное.',
    homeButton: 'На главную',
    projectsButton: 'Проекты',
  },
  contact: {
    title: 'Обсудим задачу',
    description: 'Напишите или позвоните - ответим в течение рабочего дня.',
    phoneLabel: 'Телефон',
    emailLabel: 'Почта',
    addressLabel: 'Адрес',
  },
  footer: {
    sectionsTitle: 'Разделы',
    requisitesTitle: 'Реквизиты',
    contactsTitle: 'Контакты',
    rightsReserved: 'Все права защищены.',
  },
  workCard: {
    openProject: 'Открыть проект',
    details: 'Подробнее',
    openInNewTab: (title) => `${title} — открыть в новой вкладке`,
  },
};

export default content;
